import { useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { NETWORK_CONNECTION_FAILURE_TEXT } from "../../Constants/constants";
import { TEST_YOUR_CONNECTION_DETAILS } from "../../Pages/Home/Components/NetworkStatus/query";
import {
  setNetworkConnectionDetails,
  setNetworkStatusOnline,
  setTestConnectionApiError,
  setTestConnectionApiErrorMsg,
  setTestConnectionLoading,
  setTestDetailsNull,
} from "../../Redux/Slices/NetworkStatusSlice";

export const useTestConnection = (accountNumber: any) => {
  const dispatch = useDispatch();

  const [getTestConnectionDetails, { loading }] = useLazyQuery(TEST_YOUR_CONNECTION_DETAILS, {
    variables: {
      accountNumber: accountNumber,
    },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      dispatch(setNetworkConnectionDetails(data?.testYourConnection?.connectionDetails));
      if (data?.testYourConnection?.connectionDetails === null) {
        dispatch(setNetworkStatusOnline(false));
        dispatch(setTestConnectionApiErrorMsg(NETWORK_CONNECTION_FAILURE_TEXT));
        dispatch(setTestDetailsNull(true));
      } else {
        if (data?.testYourConnection?.connectionDetails?.testStatus.toLowerCase() === "tested ok") {
          dispatch(setNetworkStatusOnline(true));
        } else {
          dispatch(setNetworkStatusOnline(false));
        }
        dispatch(setTestConnectionApiError(false));
        dispatch(setTestDetailsNull(false));
      }
      dispatch(setTestConnectionLoading(false));
    },
    onError: () => {
      dispatch(setNetworkStatusOnline(false));
      dispatch(setTestConnectionApiError(true));
      dispatch(setTestConnectionApiErrorMsg(NETWORK_CONNECTION_FAILURE_TEXT));
      dispatch(setNetworkConnectionDetails({}));
      dispatch(setTestDetailsNull(false));
      dispatch(setTestConnectionLoading(false));
    },
  });

  return {
    getTestConnectionDetails,
    loading,
  };
};
